import "./index.0.css";
import { INJECT_UICORE_BUS, INJECT_UICORE_RENDERER } from "../../../../lib/utils/consts";
const __script_base__ = {
  name: 'WTabPane',
  props: {
    badgeText: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    ucPresetIndex: {
      type: Number,
      default: null
    }
  },
  inject: {
    // 这些是给 w-array-tabs 的
    tabsContainer: {
      from: 'uicore:WTabs',
      default: null
    },
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    },
    renderer: {
      from: INJECT_UICORE_RENDERER,
      default: null
    }
  },
  created() {
    this.isTabPane = true;
    if (this.tabsContainer && typeof this.tabsContainer.registerTabPane === 'function') {
      this.tabsContainer.registerTabPane(this);
    }
  },
  computed: {
    index() {
      var _this$ucPresetIndex, _this$renderer;
      return (_this$ucPresetIndex = this.ucPresetIndex) !== null && _this$ucPresetIndex !== void 0 ? _this$ucPresetIndex : (_this$renderer = this.renderer) === null || _this$renderer === void 0 || (_this$renderer = _this$renderer.data) === null || _this$renderer === void 0 ? void 0 : _this$renderer.index;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    ref: "container",
    staticClass: "uc-tabs-content uc-slotForBlocks"
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/TabPane/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);